import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useLocation
} from "react-router-dom";
import "./App.scss";
import { useDispatch } from "react-redux";

import { setFunds } from "./store/slices/donation";
import CustomSpinner from "./components/CustomSpinner";
import Home from "./pages/Home";
import Donation from "./pages/Donation";
import ManageDonation from "./pages/ManageDonation";
import Navbar from "./components/Navbar";
import "./i18n"; // <-- import i18n configuration
import FbPixelProvider from "./analytics/FbPixel";
import GtmProvider from "./analytics/GtmProvider";
import { ACTIVE_FUNDS } from "./utils/constants";
import {
  getCanonicalTemplateKey,
  isDhulHijjahTemplateKey,
  isFridayTemplateKey
} from "./utils/templateUtils";

function App() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadFundsAndCampaigns = async () => {
      const fundNameOverrides = {
        "9": "Thirst Relief"
      };
      const normalizedFunds = ACTIVE_FUNDS.map((fund) => {
        const override = fundNameOverrides[String(fund.fundId)];
        return override ? { ...fund, name: override } : fund;
      });
      dispatch(setFunds(normalizedFunds));
      setLoading(false);
    };

    loadFundsAndCampaigns();
  }, [dispatch]);

  if (loading) {
    return (
      <div className="app-loading-container">
        <CustomSpinner />
      </div>
    );
  }

  return (
    <Router>
      <ThemeWrapper>
        <Navbar />
        <GtmProvider>
          <FbPixelProvider>
            <Routes>
              <Route path="/" element={<Navigate to="/home" replace />} />
              <Route path="/home" element={<Home />} />
              <Route path="/donate" element={<Donation />} />
              <Route
                path="/manage-donation/:scheduleId"
                element={<ManageDonation />}
              />
            </Routes>
          </FbPixelProvider>
        </GtmProvider>
      </ThemeWrapper>
    </Router>
  );
}

function ThemeWrapper({ children }) {
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const templateRaw = searchParams.get("template") || "";
    const template = getCanonicalTemplateKey(templateRaw);
    const ref = searchParams.get("ref");

    document.body.classList.remove("theme-rajab");
    document.body.classList.remove("theme-fridays");
    document.body.classList.remove("theme-dhul-hijjah");
    document.body.classList.remove("theme-hijri");
    document.body.classList.remove("theme-lunar");
    document.body.classList.remove("theme-ogn");

    if (!template) {
      document.body.classList.add("theme-lunar");
      return;
    }

    if (template === "rajab") {
      document.body.classList.add("theme-rajab");
      return;
    }

    if (isFridayTemplateKey(template)) {
      if (ref && ref.toLowerCase().includes("ogn")) {
        document.body.classList.add("theme-ogn");
      } else {
        document.body.classList.add("theme-fridays");
      }
      return;
    }

    if (isDhulHijjahTemplateKey(template)) {
      document.body.classList.add("theme-dhul-hijjah");
      return;
    }

    if (template.includes("hijri")) {
      document.body.classList.add("theme-hijri");
      return;
    }

    if (template.includes("lunar")) {
      document.body.classList.add("theme-lunar");
      return;
    }

    // Fallback
    document.body.classList.add("theme-lunar");
  }, [location.search]);

  return children;
}

export default App;
